<template>
  <div>
    <v-dialog v-model="mostra" width="900" persistent>
      <v-toolbar color="primary" dense class="white--text">
        <v-toolbar-title>Test registri macchina</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn small @click="SendRegistriMacchina()"
          ><v-icon color="success">mdi-send</v-icon></v-btn
        >
        <v-spacer></v-spacer>
        <v-btn small @click="chiudiDialog()"
          ><v-icon color="red">mdi-close</v-icon></v-btn
        >
      </v-toolbar>
      <v-card>
        <v-card-text>
          <v-container>
            <v-row v-if="obj != null">
              <v-col
                cols="6"
                v-for="(item, index) in obj[0].register_fields"
                :key="'register_n#' + index"
              >
                <DynamicInput
                  :items="item.values"
                  :type="item.type"
                  :label="item.name"
                  v-model="obj.module.registers[0][item.field]"
                />
              </v-col>
              <v-col
                cols="6"
                v-for="(item, index) in obj[0].variable_fields"
                :key="'variable_n#' + index"
              >
                <DynamicInput
                  :items="item.values"
                  :type="item.type"
                  :label="item.name"
                  v-model="obj.module.registers[0][item.field]"
                />
              </v-col>
              <v-col cols="6"> </v-col>
            </v-row>
            <v-row>
              <v-list v-if="test_results != ''" dense disabled>
                <v-subheader><b>Esiti test:</b></v-subheader>
                <div style="height:100px;overflow-y:scroll;pointer-events:all">
                  <v-list-item-group >
                    <v-list-item v-for="(item, i) in test_results" :key="i">
                      <v-list-item-icon>
                        <v-icon
                          v-text="item.icon"
                          :color="item.icon_color"
                        ></v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <span :style="`color:${item.text_color}`">
                          <b>
                            <i>{{ item.date }}</i>
                          </b> - {{item.text}}
                        </span>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </div>                
              </v-list>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <SnackbarQV ref="SnackbarQV" />
  </div>
</template>
<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
import _ from "lodash";
import DynamicInput from "../.common/DynamicInput.vue";
export default {
  components: {
    SnackbarQV,
    DynamicInput,
  },
  props: {},
  data: () => ({
    NETWORK: null,
    mostra: false,
    obj: null,
    schema: null,
    test_results: [],
  }),
  watch: {
    schema: {
      immediate: true,
      handler() {
        if (this.schema != null) {
          this.obj = _.cloneDeep(this.schema);
          this.obj.id_dispositivo = this.schema.id_dispositivo;
          this.obj.module = {
            module_id: this.obj[0].id_modulo,
            interface_id: this.obj[0].interface_id,
            machine_id: parseInt(this.schema.machine_id),
            registers: [{_uid:0}],
          };
        }
      },
    },
  },
  methods: {
    chiudiDialog() {
      this.mostra = false;
      this.test_results = [];
    },
    SendRegistriMacchina() {
      let that = this;
      const request = {
        controller: "quickconnext",
        endpoint : 'connext',
        response: { parse: false },
        showdialog: false,
        body: {
          action: "machineregisterstest",
          token: localStorage.user_token,
          id_dispositivo: this.obj.id_dispositivo,
          module: this.obj.module,
        },
        method: "PUT",
        on: {
          load: function (response) {
            let res = JSON.parse(response);
            let date = new Date();
            let obj_result = {
              text: res.detail,
              text_color: res.status ? "green" : "orange",
              icon: res.status ? "mdi-check-outline" : "mdi-alert",
              icon_color: res.status ? "green" : "orange",
               date:
                date.getFullYear() +
                "-" +
                (date.getMonth() + 1 < 10
                  ? "0" + date.getMonth()
                  : date.getMonth() + 1) +
                "-" +
                (date.getDay() < 10 ? "0" + date.getDay() : date.getDay()) +
                " " +
                (date.getHours() < 10
                  ? "0" + date.getHours()
                  : date.getHours()) +
                ":" +
                (date.getMinutes() < 10
                  ? "0" + date.getMinutes()
                  : date.getMinutes()) +
                ":" +
                (date.getSeconds() < 10
                  ? "0" + date.getSeconds()
                  : date.getSeconds()),
            };
            that.test_results.unshift(obj_result);
          },
          error: function (err) {
            that.$refs.SnackbarQV.print("error", err.srcElement.responseText);
            let date = new Date();
            let obj_result = {
              text: err.srcElement.responseText,
              text_color: "red",
              icon: "mdi-close-outline",
              icon_color: "red",
              date:
                date.getFullYear() +
                "-" +
                (date.getMonth() + 1 < 10
                  ? "0" + date.getMonth()
                  : date.getMonth() + 1) +
                "-" +
                (date.getDay() < 10 ? "0" + date.getDay() : date.getDay()) +
                " " +
                (date.getHours() < 10
                  ? "0" + date.getHours()
                  : date.getHours()) +
                ":" +
                (date.getMinutes() < 10
                  ? "0" + date.getMinutes()
                  : date.getMinutes()) +
                ":" +
                (date.getSeconds() < 10
                  ? "0" + date.getSeconds()
                  : date.getSeconds()),
            };
            that.test_results.unshift(obj_result);
          },
        },
      };
      this.NETWORK.AjaxRequest(request);
    },
  },
  mounted() {
    this.NETWORK = this.$store.state.Network;
  },
};
</script>
